import { handleGetColecction } from '@/constantes/helpers';
import firebase from '@/firebase'
//const storage = firebase.storage().ref();
const db = firebase.firestore();
import { FS_COLLECTIONS } from '@/firebase'

const store = {
  state: {
    servicios: {},
    serviciosLista:{},
    serviciosPorCategoria:[],
    serviciosPorSubcategoria:[],
    serviciosPorPrincipales:[],
    serviciosPorPrincipalesGeneral:[],
    catalogo_servicios:{},
    servicioSelect:{},
    servicioSucursal: {},
    serviciosPorSucursal:[],
  },
  getters: {
      servicios: state => state.servicios,
      serviciosLista: state => state.serviciosLista,
      serviciosPorCategoria: state => state.serviciosPorCategoria,
      serviciosPorSubcategoria: state => state.serviciosPorSubcategoria,
      serviciosPorPrincipales: state => state.serviciosPorPrincipales,
      serviciosPorPrincipalesGeneral: state => state.serviciosPorPrincipalesGeneral,
      catalogoServicios:state => state.catalogo_servicios,
      servicioSeleccionado: state => state.servicioSelect,
      dataServiciosSucursal: state => state.servicioSucursal,
      serviciosPorSucursal: state => state.serviciosPorSucursal,
  },
  mutations: {
      ASIGNA_SERVICIOS(state, data){
        state.servicios = data;
      },
      ASIGNA_SERVICIOS_LISTA(state,data){
        state.serviciosLista = data;
      },
      ASIGNA_SERVICIOS_POR_CATEGORIA(state,data){
        state.serviciosPorCategoria = data;
      },
      ASIGNA_SERVICIOS_POR_SUBCATEGORIA(state,data){
        state.serviciosPorSubcategoria = data;
      },
      ASIGNA_SERVICIOS_POR_PRINCIPALES(state, data) {
        state.serviciosPorPrincipales = data;
      },
      ASIGNA_SERVICIOS_POR_PRINCIPALES_GENERAL(state,data){
        state.serviciosPorPrincipalesGeneral = data;
      },
      ASIGNA_CATALOGO_SERVICIOS(state, data){
        state.catalogo_servicios = data;
      },
      ASIGNA_SERVICIO_SELECCIONADO(state, data) {
        state.servicioSelect = data;
      },
      ASIGNA_SERVICIOS_SUCURSAL(state, data) {
        state.servicioSucursal = data;
      },
      ASIGNA_SERVICIOS_POR_SUCURSAL(state,data){
        state.serviciosPorSucursal = data
      }
  },
  actions: {

    restablecerValoresServicios({commit}){
      commit('ASIGNA_SERVICIOS_POR_CATEGORIA',[])
      commit('ASIGNA_SERVICIOS_POR_SUBCATEGORIA',[])
      commit('ASIGNA_SERVICIOS_POR_PRINCIPALES',[])
      commit('ASIGNA_SERVICIOS_POR_PRINCIPALES_GENERAL',[])
      commit('ASIGNA_SERVICIO_SELECCIONADO', {})
      commit('ASIGNA_CATALOGO_SERVICIOS',{});
    },
    async obtenerServiciosFiltrados({getters},payload){

      const ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
      .collection(FS_COLLECTIONS.SERVICIOS)

      return await handleGetColecction(ref)


    },
    cargaServicioSeleccionado({ commit, getters }, idServicio) {
      console.log('Store servicio carga: ' + idServicio + " de la franquicia " + getters.franquicia.id);
      return new Promise((resolve, reject) => {
        let docPath = db.collection("Franquicias").doc(getters.franquicia.id)
        .collection("Servicios").doc(idServicio);
        docPath.get().then(doc => {
          commit('ASIGNA_SERVICIO_SELECCIONADO', doc.data())
          resolve(doc.data())
        })
      })
    },

    actualizaServicioSeleccionado({getters}, data) {
      console.log(data);
      db.collection("Franquicias").doc(getters.franquicia.id)
      .collection("Servicios").doc(data[1]).set(data[0]);
      db.collection("Franquicias").doc(getters.franquicia.id)
      .collection("Catalogos").doc("Servicios").set(data[2]);
    },

    cargaServiciosSucursal({commit}, idSucursal) {
      db.collection("Sucursales").doc(idSucursal)
      .collection("Indices").doc("Servicios").onSnapshot((querySnapshot) => {
        console.log("Lista de servicios por franquicia desde store: " + querySnapshot.data())
        console.log("Sucursal: " + idSucursal);
        let servicios = querySnapshot.data()!==undefined ? querySnapshot.data() : {};
        commit('ASIGNA_SERVICIOS_SUCURSAL',servicios);
      });
    },

    cargarServiciosPorSucursal({getters,commit}) {
      
      return new Promise((resolve) => {

        db.collection("Sucursales")
        .doc(getters.sucursal_activa.id)
        .collection("Indices")
        .doc("Servicios")
        .onSnapshot((querySnapshot) => {
          const servicios = [];
          //this.servicios = Object.values(querySnapshot.data());
          for (const i in querySnapshot.data()) {
            const data = querySnapshot.data()[i];
            if (data.activo) {
              data.id = i;
              servicios.push(data);
            }
          }
          commit('ASIGNA_SERVICIOS_POR_SUCURSAL',servicios)
          resolve()
        })

      })

    },

    cargaServicios({getters,commit}){
      return new Promise((resolve, reject) => {
          db.collection("Franquicias").doc(getters.franquicia.id)
          .collection("Catalogos").doc("Servicios").get().then((querySnapshot) => {
          //commit('ASIGNA_SERVICIOS',querySnapshot.data());
          commit('ASIGNA_CATALOGO_SERVICIOS',querySnapshot.data());
          let servicios_categoria = [];
          let servicios_subcategoria = [];
          let servicios_principales = [];
          let servicios_principales_general = []
          for(var i in querySnapshot.data().children){
            if(!querySnapshot.data().children[i].delete) {
              let categoria = querySnapshot.data().children[i];
              for(var j in categoria.children){
                if (Object.keys(categoria.children[j]).length > 0) {
                  if(!categoria.children[j].delete){
                    let subcategoria = categoria.children[j];
                    for(var k in subcategoria.children){
                      if (Object.keys(subcategoria.children[k]).length > 0) {
                        servicios_principales_general.push(subcategoria.children[k])
                        if(!subcategoria.children[k].delete){
                          let servicio_normal = subcategoria.children[k];
                          servicios_principales.push(servicio_normal);
                        }
                      }
                    }
                    //Añadir subcategoria a array de subcategorias del servicio
                    delete subcategoria.children;
                    servicios_subcategoria.push(subcategoria);
                  }
                }
              }
              //Añadir categorias a array de categorias del servicio
              delete categoria.children;
              servicios_categoria.push(categoria);
            }

          }
          commit('ASIGNA_SERVICIOS_POR_CATEGORIA',servicios_categoria)
          commit('ASIGNA_SERVICIOS_POR_SUBCATEGORIA',servicios_subcategoria)
          commit('ASIGNA_SERVICIOS_POR_PRINCIPALES',servicios_principales)
          commit('ASIGNA_SERVICIOS_POR_PRINCIPALES_GENERAL',servicios_principales_general)
          resolve(querySnapshot.data());
        });
      })
    },

    cargaServiciosParaActualizacion({getters,commit}){
      return new Promise((resolve, reject) => {
          db.collection("Franquicias").doc(getters.franquicia.id)
          .collection("Catalogos").doc("Servicios").get().then((querySnapshot) => {
          let servicios_principales_general = []
          for(var i in querySnapshot.data().children){
            let categoria = querySnapshot.data().children[i];
            for(var j in categoria.children){
              if (Object.keys(categoria.children[j]).length > 0) {
                let subcategoria = categoria.children[j];
                  for(var k in subcategoria.children){
                    if (Object.keys(subcategoria.children[k]).length > 0) {
                      servicios_principales_general.push(subcategoria.children[k])
                    }
                  }
              }
            }

          }
          commit('ASIGNA_SERVICIOS_POR_PRINCIPALES_GENERAL',servicios_principales_general)
          //console.log("🚀 ~ file: servicios.js:211 ~ .collection ~ servicios_principales_general:", servicios_principales_general)
          resolve(servicios_principales_general);
        });
      })
    },

    cargaServiciosLista({getters,commit}){
      return new Promise((resolve, reject) => {
          db.collection("Franquicias").doc(getters.franquicia.id)
          .collection("Indices").doc("ServiciosLista").onSnapshot((querySnapshot) => {
          commit('ASIGNA_SERVICIOS_LISTA',querySnapshot.data());
          resolve(querySnapshot.data());
        });
      })
    },

    inhabilitarServicio({getters}, idServicio){
      var obj = {estatus:{activo:"baja"}}
      return db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
      .collection(FS_COLLECTIONS.SERVICIOS).doc(idServicio).set(obj,{merge:true})
    },

    actualizarServiciosV1({getters, dispatch }){
      return new Promise((resolve,reject) => {
        dispatch('cargaServiciosParaActualizacion').then(() => {
          dispatch('cargaServiciosLista').then(() => {
            console.log("Actualizar servicios carga servicios", getters.serviciosPorPrincipalesGeneral)
            //Creamos las transacciones para actualizar los datos
            var batch = db.batch();
            let servicios = getters.serviciosPorPrincipalesGeneral
            let servicios_lista = getters.serviciosLista;
            /*for(var i in servicios){
              if(servicios[i].delete){
                let ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                .collection(FS_COLLECTIONS.SERVICIOS).doc(servicios[i].id)
                batch.set(ref, {estatus:{activo:"baja"}}, {merge:true})
              }
            }*/
            for(var i in servicios_lista){
              let p_temp = null
              let encontrado = false;
              for(var j in servicios){
                if(servicios[j].id==i){
                  p_temp = servicios[j]
                  encontrado = true;
                }
              }
              if(p_temp!==null){
                console.log("Servicio encontrado", p_temp)
                if(p_temp.delete){
                  let ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                  .collection(FS_COLLECTIONS.SERVICIOS).doc(p_temp.id)
                  batch.set(ref, {estatus:{activo:"baja"}}, {merge:true})
                } else {
                  let ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                  .collection(FS_COLLECTIONS.SERVICIOS).doc(p_temp.id)
                  batch.set(ref, {estatus:{activo:"activo"}}, {merge:true})
                }
              } else {
                console.log("Servicio no se encontro", servicios_lista[i])
                let ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                .collection(FS_COLLECTIONS.SERVICIOS).doc(i)
                batch.set(ref, {estatus:{activo:"baja"}}, {merge:true})
              }
              //console.log("Encontrado " + i + " " + encontrado)
              //console.log("Temp encontrato producto", p_temp)
            }
            //Cuando todas las transacciones estan listas se ejecuta esta linea
            batch.commit().then(() => {
              console.log("STORE TERMINA EJECUCION SERVICIOS")
              //Actualizamos rama de productos a version 1.0
              db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
              .collection(FS_COLLECTIONS.CATALOGOS).doc(FS_COLLECTIONS.SERVICIOS)
              .set({version:'1.0'},{merge:true}).then(() => {
                resolve(true)
              }).catch(error => {
                reject(error);
              })
            }).catch(error => {
              reject(error)
            })
          }).catch(error => {
            reject(error)
          })

        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/servicios/servicios.js